import React from 'react';

interface CertificateExpiredIconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

export const CertificateExpiredIcon: React.FC<CertificateExpiredIconProps> = ({
  width = 20,
  height = 20,
  className = '',
  color = '#DC2626',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="受給者証期限切れ"
    >
      <g clipPath="url(#clip0_853_14657)">
        <path
          d="M12.9746 4.08585C11.6233 3.00429 11.0947 1.81046 10.8915 0.962062C10.7285 0.280305 10.8152 0.207062 10.8152 0.207062C10.8066 0.125891 10.7566 0.0556953 10.6821 0.0215156C10.6089 -0.0126641 10.5222 -0.00594534 10.4557 0.0404219C10.4557 0.0404219 10.1939 0.0971797 9.7666 0.511633C8.79492 1.45523 7.69508 3.02995 8.42016 5.18265C9.19715 7.49222 8.78637 7.97562 8.37926 7.9439C7.85129 7.90363 7.76953 7.57831 7.85434 6.56632C7.95262 5.38347 6.87961 4.37331 6.87961 4.37331C6.87961 4.37331 5.21273 7.02347 3.9127 8.91921C3.14426 10.0398 2.77562 11.4638 2.77562 12.7632H2.75C2.75 16.7598 5.98977 20.0001 9.98633 20.0001C13.9829 20.0001 17.2227 16.7598 17.2227 12.7632C17.4973 9.29277 15.6125 6.19581 12.9746 4.08585ZM9.99914 17.9622C7.79516 17.9622 6.00742 16.1751 6.00742 13.9705C6.00742 13.2197 6.21555 12.5178 6.57566 11.9178C6.88574 13.0726 7.93918 13.9228 9.19164 13.9228C10.687 13.9228 11.9004 12.7101 11.9004 11.2141C11.9004 10.9291 11.8552 10.6532 11.7734 10.395C13.0881 11.0481 13.9909 12.4037 13.9909 13.9704C13.9908 16.1751 12.2037 17.9622 9.99914 17.9622Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_853_14657">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CertificateExpiredIcon;
